// extracted by mini-css-extract-plugin
module.exports = {"block":"dmbc-commodity_evaluate-block","bg":"dmbc-commodity_evaluate-bg"};